import * as React from "react";
import {ListTableStore} from "../../../stores/ListTableStore";
import {api} from '../../../api';
import {ListTable} from "../../list/ListTable";
import {Button, Col, Row} from "reactstrap";
import {Input} from "../../form/fields/Input";
import {Field} from "../../form/Field";
import {FormStore} from "../../../stores/FormStore";
import {debounce} from 'lodash';
import {observable} from "mobx";


class FilterForm {
    @observable name = '';
}

class SearchForm {
    @observable search = '';
}

export class ListTablePage extends React.Component {
    listTableStore: ListTableStore;
    @observable filterFormStore: FormStore<FilterForm>;
    @observable searchFormStore: FormStore<SearchForm>;

    constructor(props: any) {
        super(props);

        this.listTableStore = new ListTableStore(
            api.state.getListAction,
            1,
        );

        this.filterFormStore = new FormStore(new FilterForm());
        this.filterFormStore.onChangeCallback = debounce((data: any) => {
            this.listTableStore.setFilters(data);
        }, 200);

        this.searchFormStore = new FormStore(new SearchForm());
        this.searchFormStore.onChangeCallback = debounce((data: any) => {
            this.listTableStore.setSearch(data.search);
        }, 200);
    }

    render() {
        return (
            <div>
                <h1 className="main-heading pb-3">List Table Docs</h1>
                <div className="box-shadow p-3 p-md-4">
                    <Row className="form-row">
                        <Col md={3}>
                            <Field
                                placeholder="Name"
                                name="name"
                                component={Input}
                                required={true}
                                store={this.filterFormStore}
                            />
                        </Col>

                        <Col md={3} className="grid-search">
                            <Field
                                placeholder="Search"
                                name="search"
                                component={Input}
                                required={true}
                                store={this.searchFormStore}
                                addon={{
                                    type: 'append',
                                    component: <span className="icon-search"/>
                                }}
                            />
                        </Col>
                    </Row>

                    <ListTable
                        store={this.listTableStore}
                        columns={[
                            {
                                name: "id",
                                label: "#",
                                style: {width: 50,},
                            },
                            {
                                name: "name",
                                label: "Name",
                            },
                            {
                                name: "capital",
                                label: "Capital",
                            },
                            {
                                name: "id",
                                label: "Actions",
                                formatter: (value: any) => {
                                    return (
                                        <>
                                            <Button onClick={() => alert('Id ' + value)} size="sm" className="btn-edit"><span className="icon-edit"/></Button>
                                        </>
                                    );
                                },
                                style: {width: 140, textAlign: 'center'},
                            },
                        ]}
                    />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/docs/ListTablePage.tsx